import React from 'react';
import PropTypes from 'prop-types';
import { addMonths, startOfYear } from 'date-fns';
import { useTranslation } from 'next-i18next';

import { formatDate } from '@spa/shared/utils/date';
import { Wrapper, Year, YearTitle, Months, Month, MonthTitle, MonthPrice, Legend } from './styles';
import { getMonthClassName, getMonthPrice } from '@spa/shared/utils/avalabilityCalculations';

const Years = ({ accommodationOffer }) => {
  const {
    t,
    i18n: { language }
  } = useTranslation();

  const generatedMonths = Array.from({ length: 24 }, (_, index) => {
    const today = new Date();
    const startYear = startOfYear(today);
    const date = addMonths(startYear, index);
    const month = formatDate(date, language, 'MMM');
    const year = date.getFullYear();
    const blockedIntervals = accommodationOffer.availabilities?.standard_unitary?.blocked_intervals || [];
    const className = getMonthClassName(date, blockedIntervals);

    return {
      year,
      month,
      price: getMonthPrice(date, accommodationOffer, t),
      ...className
    };
  });

  const groupedMonths = generatedMonths.reduce((acc, monthData) => {
    const rest = acc[monthData.year] || [];

    return { ...acc, [monthData.year]: [...rest, monthData] };
  }, {});

  return (
    <Wrapper>
      {Object.entries(groupedMonths).map(([year, months]) => (
        <Year key={year}>
          <YearTitle>{year}</YearTitle>
          <Months>
            {months.map((monthData, index) => (
              <Month key={`${year}-${index}`} className={`${monthData.className}`}>
                {monthData.childClassName && <span className={monthData.childClassName}></span>}
                <MonthTitle>{monthData.month}</MonthTitle>
                <MonthPrice>{monthData.price}</MonthPrice>
              </Month>
            ))}
          </Months>
        </Year>
      ))}
      <Legend>
        <span>{t('Available')}</span>
        <span>{t('Occupied')}</span>
      </Legend>
    </Wrapper>
  );
};

Years.propTypes = {
  accommodationOffer: PropTypes.object.isRequired
};

export default Years;
